import React from 'react';
import { IconButton, Box } from '@mui/material';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import FacebookIcon from '@mui/icons-material/Facebook';
import XIcon from '@mui/icons-material/X';
import LinkedInIcon from '@mui/icons-material/LinkedIn';

const SocialMediaButtons: React.FC = () => {
  return (
    <Box display="flex" gap={1}>
      <IconButton
        style={{ backgroundColor: '#25D366', color: 'white' }}
        aria-label="WhatsApp"
        href="https://wa.me/"
        target="_blank"
      >
        <WhatsAppIcon />
      </IconButton>

      <IconButton
        style={{ backgroundColor: '#1877F2', color: 'white' }}
        aria-label="Facebook"
        href="https://facebook.com"
        target="_blank"
      >
        <FacebookIcon />
      </IconButton>

      <IconButton
        style={{ backgroundColor: '#000', color: 'white' }}
        aria-label="Twitter"
        href="https://twitter.com"
        target="_blank"
      >
        <XIcon />
      </IconButton>

      <IconButton
        style={{ backgroundColor: '#0077B5', color: 'white' }}
        aria-label="LinkedIn"
        href="https://linkedin.com"
        target="_blank"
      >
        <LinkedInIcon />
      </IconButton>
    </Box>
  );
};

export default SocialMediaButtons;
